import React from 'react';
import { Field } from 'formik';
import Heading from '@nib-components/heading';
import { addMonths, isDate } from 'date-fns';
import { FullName, NestedFormFields, VisaSubclass, Email, Phone, CoverStartDate, VisaEndDate } from '../..';
import { Stack } from '@nib/layout';
import Copy from '@nib-components/copy';
import { StandardInfoBox } from '../info-box';
const VisaSubclassGroup = props => {
  const {
    id = 'visaSubclass',
    name = 'visaSubclass',
    label,
    help,
    visas = {},
    values = {},
    infoText = "We need your sponsor's details for your visa certificate, if you don't have them we'll call and ask for them later. Don't worry, we won't be sharing your health details with your sponsor.",
    optional = false,
    groupOnBlurHandlers,
    groupOnChangeHandlers,
    suggestionsTitle
  } = props;
  const selectedVisa = visas && values ? visas[values[id]] : '';
  const expanded = !!selectedVisa && (selectedVisa.showEstimatedVisaStartDate || selectedVisa.showExpectedVisaEndDate || selectedVisa.showSponsorDetails);
  const visaArray = Object.keys(visas).map(visa => ({
    value: visa,
    text: `${visa} - ${visas[visa].name}`
  }));
  const suggestedVisaArray = Object.keys(visas).filter(visa => visas[visa].showInSuggestions).map(visa => ({
    value: visa,
    text: `${visa} - ${visas[visa].name}`
  }));
  // Prevent user from selecting an end date within a month of start date
  let endDateMinDate = new Date();
  if (selectedVisa && selectedVisa.showExpectedVisaEndDate && isDate(values.coverStartDate)) {
    endDateMinDate = addMonths(values.coverStartDate, 1);
  }
  return React.createElement("div", null, React.createElement(Field, {
    name: name,
    id: id,
    label: label,
    help: help,
    component: VisaSubclass,
    optional: optional,
    options: visaArray,
    suggestions: suggestedVisaArray.length ? suggestedVisaArray : null,
    onChange: groupOnChangeHandlers === null || groupOnChangeHandlers === void 0 ? void 0 : groupOnChangeHandlers.visaSubclass,
    suggestionsTitle: suggestionsTitle
  }), React.createElement(NestedFormFields, {
    expanded: expanded
  }, selectedVisa && selectedVisa.showEstimatedVisaStartDate && React.createElement(Field, {
    name: "coverStartDate",
    id: "coverStartDate",
    component: CoverStartDate,
    months: selectedVisa.maxEstimatedVisaStartDateMonths,
    onChange: groupOnChangeHandlers === null || groupOnChangeHandlers === void 0 ? void 0 : groupOnChangeHandlers.coverStartDate
  }), selectedVisa && selectedVisa.showExpectedVisaEndDate && React.createElement(Field, {
    name: "visaEndDate",
    id: "visaEndDate",
    component: VisaEndDate,
    minDate: endDateMinDate,
    months: selectedVisa.maxExpectedVisaEndDateMonths,
    help: selectedVisa.requireExpectedVisaEndDate ? null : '(optional)',
    optional: !selectedVisa.requireExpectedVisaEndDate,
    coverStartDate: new Date(values.coverStartDate),
    onChange: groupOnChangeHandlers === null || groupOnChangeHandlers === void 0 ? void 0 : groupOnChangeHandlers.visaEndDate
  }), selectedVisa && selectedVisa.showSponsorDetails && React.createElement(Stack, {
    space: 4
  }, React.createElement(Heading, {
    size: 3
  }, "Sponsor details"), infoText && React.createElement(StandardInfoBox, {
    withTip: false
  }, React.createElement(Copy, null, infoText)), React.createElement(Field, {
    name: "sponsorName",
    id: "sponsorName",
    label: "Sponsor name",
    help: "(optional)",
    optional: true,
    component: FullName,
    maxLength: 100,
    onBlur: groupOnBlurHandlers === null || groupOnBlurHandlers === void 0 ? void 0 : groupOnBlurHandlers.sponsorName
  }), React.createElement(Field, {
    name: "sponsorEmailAddress",
    id: "sponsorEmailAddress",
    label: "Sponsor email address",
    help: "(optional)",
    optional: true,
    component: Email,
    onBlur: groupOnBlurHandlers === null || groupOnBlurHandlers === void 0 ? void 0 : groupOnBlurHandlers.sponsorEmailAddress
  }), React.createElement(Field, {
    name: "sponsorPhone",
    id: "sponsorPhone",
    label: "Sponsor phone number",
    help: "(optional)",
    optional: true,
    component: Phone,
    onBlur: groupOnBlurHandlers === null || groupOnBlurHandlers === void 0 ? void 0 : groupOnBlurHandlers.sponsorPhone,
    maxLength: 10
  }))));
};
export default VisaSubclassGroup;